import React from "react";
import { Container, Dot, Span } from "../../Styles/Global.Styled";
import { css } from "styled-components";

const cntBox = css`
  z-index: 3;
  background-color: white;
  align-items: center;
`;
const dotStyle = (isValid) => css`
  height: 0.5vh;
  width: 0.5vh;
  background-color: ${isValid ? "green" : "red"};
`;
const txtStyle = (isValid) => css`
  font-size: 1.2vh;
  white-space: nowrap;
  color: ${isValid ? "green" : "red"};
`;

const PasswordHelper = ({ checks = [] }) => {
  return (
    <>
      {checks.map((check, index) => (
        <Container key={index} $baseStyle={cntBox}>
          <Dot $baseStyle={dotStyle(check.isValid)} />
          <Span $baseStyle={txtStyle(check.isValid)}>{check.rule}</Span>
        </Container>
      ))}
    </>
  );
};

export default PasswordHelper;
